import {cloneElement, useCallback, useEffect, useRef} from "react";

export default function FocusTrap({
                                      isOpened, setIsOpened,
                                      dataId="",
                                      // focusOnFirstEle=false,
                                      enableArrowKey=false,
                                      onCloseCb,
                                      children
}) {
    const trapRef = useRef(null);

    // --- The Ref Merging Function ---
    const setRefs = useCallback(
        (node) => {
            // Your internal ref gets the DOM node
            trapRef.current = node;

            // Get the ref that was originally passed to the child element
            const userRef = children.ref;

            if (typeof userRef === 'function') {
                userRef(node);
            } else if (userRef && typeof userRef === 'object') {
                // Ensure the ref object is mutable (i.e., has a .current property)
                userRef.current = node;
            }
        }, [children.ref] // Only recreate if the user's ref changes
    );

    const handleTabKeydown = (event) => {
        if (event.key === 'Escape') {
            if (!!setIsOpened) {

                if (!!onCloseCb) {
                    onCloseCb();
                } else {
                    setIsOpened(false);
                }
            }
            event.preventDefault();
            return;
        }

        if (event.key !== "Tab") {
            return;
        }

        let container = dataId ? document.getElementById(dataId) : trapRef.current;
        if (!(container instanceof HTMLElement)) {
            container = container.hasOwnProperty("dialog") ? container = container.dialog : null;
        }

        if (!container) {
            return;
        }

        let focusableElements = container.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([disabled]), input:not([tabindex="-1"]):not([disabled])');

        focusableElements = Array.from(focusableElements).filter(el => {
            // Check if the element itself or any parent is hidden
            const style = window.getComputedStyle(el);
            return style.display !== 'none' && style.visibility !== 'hidden';
        });

        if (!container.contains(event.target)) {
            event.preventDefault();
            focusableElements[0].focus();
            return;
        }

        if (event.shiftKey) {
            for (let i = 0; i < focusableElements.length; i++) {
                if (focusableElements[i] !== event.target) {
                    continue;
                }
                if (i === 0) {
                    event.preventDefault();
                    focusableElements[focusableElements.length - 1].focus();
                    return;
                } else {
                    event.preventDefault();
                    focusableElements[i - 1].focus();
                    return;
                }
            }
        } else {
            for (let i = 0; i < focusableElements.length; i++) {
                if (focusableElements[i] !== event.target) {
                    continue;
                }
                if (i === focusableElements.length - 1) {
                    event.preventDefault();
                    focusableElements[0].focus();
                    return;
                } else {
                    event.preventDefault();
                    focusableElements[i + 1].focus();
                    return;
                }
            }
        }

    };


    const handleKeydown = (event) => {
        if (event.key === 'Escape') {
            if (!!setIsOpened) {
                if (!!onCloseCb) {
                    onCloseCb();
                } else {
                    setIsOpened(false);
                }
            }
            event.preventDefault();
            return;
        }

        if (event.key !== "Tab" && event.key !== "ArrowUp" && event.key !== "ArrowDown") {
            return;
        }

        let container = dataId ? document.getElementById(dataId) : trapRef.current;
        if (!(container instanceof HTMLElement)) {
            container = container.hasOwnProperty("dialog") ? container = container.dialog : null;
        }

        if (!container) {
            return;
        }

        let focusableElements = container.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([disabled]), input:not([tabindex="-1"]):not([disabled])');

        focusableElements = Array.from(focusableElements).filter(el => {
            // Check if the element itself or any parent is hidden
            const style = window.getComputedStyle(el);
            return style.display !== 'none' && style.visibility !== 'hidden';
        });

        if (!container.contains(event.target)) {
            event.preventDefault();
            focusableElements[0].focus();
            return;
        }

        if ((event.shiftKey && event.key === "Tab") || event.key  === "ArrowUp") {
            for (let i = 0; i < focusableElements.length; i++) {
                if (focusableElements[i] !== event.target) {
                    continue;
                }
                if (i === 0) {
                    event.preventDefault();
                    focusableElements[focusableElements.length - 1].focus();
                    return;
                } else {
                    event.preventDefault();
                    focusableElements[i - 1].focus();
                    return;
                }
            }
        } else {
            for (let i = 0; i < focusableElements.length; i++) {
                if (focusableElements[i] !== event.target) {
                    continue;
                }
                if (i === focusableElements.length - 1) {
                    event.preventDefault();
                    focusableElements[0].focus();
                    return;
                } else {
                    event.preventDefault();
                    focusableElements[i + 1].focus();
                    return;
                }
            }
        }

    };

    useEffect(() => {
        if (!!isOpened) {
            if (enableArrowKey) {
                document.addEventListener("keydown", handleKeydown);
            } else {
                document.addEventListener("keydown", handleTabKeydown);

            }
            //
            // const container = trapRef.current;
            // let focusableElements = container.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([disabled]), input:not([tabindex="-1"]):not([disabled])');
            // if (focusOnFirstEle && Array.from(focusableElements).length > 0) {
            //     Array.from(focusableElements)[0].focus();
            // }
        }


        return () => {
            if (enableArrowKey) {
                document.removeEventListener("keydown", handleKeydown);
            } else {
                document.removeEventListener("keydown", handleTabKeydown);
            }
        };
    }, [isOpened, dataId]);

    // Pass the merging function as the new ref
    return cloneElement(children, {ref: setRefs});
}